<template>
  <article>
    <section class="xbed-sub-title">
      <span>门店详情</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理</BreadcrumbItem>
        <BreadcrumbItem>门店详情</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
      <TabPane label="渠道门店信息" name="channelInfo" ref="channelInfo">
        <Form label-position="left" class="hotel-info" :label-width="110">
          <FormItem label="渠道门店ID：" prop="title">
            <span>{{ channelInfo.channelHotelId }}</span>
          </FormItem>
          <FormItem label="渠道门店名称：" prop="title">
            <span>{{ channelInfo.channelHotelName }}</span>
          </FormItem>
          <FormItem label="渠道门店地址：" prop="title">
            <span>{{ channelInfo.address }}</span>
          </FormItem>
          <br/>
          <br/>
          <Button type="primary" @click="editHotelDetailModel=true">编辑修改</Button>
        </Form>
      </TabPane>
      <TabPane label="xbed门店信息" name="xbedHotelInfo" ref="xbedHotelInfo">
        <Form label-position="left" class="hotel-info" :label-width="110">
          <FormItem label="xbed门店ID：" prop="title">
            <span>{{ xbedHotelInfo.xbedHotelId }}</span>
          </FormItem>
          <FormItem label="门店名称：" prop="title">
            <span>{{ xbedHotelInfo.xbedHotelName }}</span>
          </FormItem>
          <FormItem label="主要联系人：" prop="title">
            <span>{{ xbedHotelInfo.contactName }}</span>
          </FormItem>
          <FormItem label="主要联系电话：" prop="title">
            <span>{{ xbedHotelInfo.contactPhone }}</span>
          </FormItem>
          <!-- <FormItem label="所属热点：" prop="title">
            <span>{{ xbedHotelInfo.hotspot }}</span>
          </FormItem> -->
          <FormItem label="省份：" prop="title">
            <span>{{ xbedHotelInfo.province }}</span>
          </FormItem>
          <FormItem label="城市：" prop="title">
            <span>{{ xbedHotelInfo.city }}</span>
          </FormItem>
          <FormItem label="区域：" prop="title">
            <span>{{ xbedHotelInfo.district }}</span>
          </FormItem>
          <FormItem label="街道地址：" prop="title">
            <span>{{ xbedHotelInfo.address }}</span>
          </FormItem>
          <FormItem label="门店提醒：" prop="title">
            <span>{{ xbedHotelInfo.reminder }}</span>
          </FormItem>
        </Form>
      </TabPane>
      <TabPane label="门店房型列表" name="roomTypeList" ref="roomTypeList" style="margin-left: 1px">
        <section>
          <Form :model="roomTypeList.form" @submit.native.prevent="preventSubmit" inline>
            <FormItem prop="keyword" label="房型名称：" :label-width="84">
              <Input type="text" v-model="roomTypeList.form.keyword" placeholder="查询关键字"></Input>
            </FormItem>
            <FormItem prop="isPackaged" label="打包状态：" :label-width="84">
              <Select v-model="roomTypeList.form.isPackaged" filterable>
                <Option value="-1">全部</Option>
                <Option value="1">已打包</Option>
                <Option value="0">未打包</Option>
              </Select>
            </FormItem>
            <FormItem prop="roomTypeQuery">
              <Button type="primary" @click="queryWidthCondition">查询</Button>
            </FormItem>
            <FormItem>
              <Button v-if="matchStatusCode=='S51'" type="primary" @click="openAddModal">新增房型</Button>
            </FormItem>
          </Form>
          <Table stripe :loading="roomTypeList.loading" height="450" :columns="roomTypeList.columns" :data="roomTypeList.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </section>
      </TabPane>
    </Tabs>

    <Modal v-model="editHotelDetailModel" ref="updateHotelNameModel" :loading="true" title="编辑渠道门店信息" @on-ok="updateHotelName" ok-text="提交" cancel-text="取消">
      <Form @submit.native.prevent="preventSubmit" :label-width="120">
        <FormItem label="渠道门店ID">
          <span>{{channelInfo.channelHotelId}}</span>
        </FormItem>
        <FormItem label="渠道门店名称">
          <Input type="text" ref="updateHotelNameModelInput" v-model="channelInfo.channelHotelName"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal v-model="addRoomType.display" ref="addRoomTypeModal" :loading="true" title="新增渠道门店房型" @on-ok="prepareAddRoomType" ok-text="新增" cancel-text="取消">
      <Form @submit.native.prevent="preventSubmit" ref="addRoomForm" label-position="left" :label-width="100" :model="addRoomType" :rules="valideForm">
        <FormItem label="房型名称：" prop="name">
          <Input type="text" v-model="addRoomType.name" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="套餐名称：" prop="ratePlanName">
          <Input type="text" v-model="addRoomType.ratePlanName" :maxlength="100"></Input>
        </FormItem>
        <FormItem label="床型" prop="bedType">
          <Select v-model="addRoomType.bedType">
              <Option v-for="(item,index) in bedTypeArr" :key="index" :value="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="床宽等描述：" prop="describe">
          <Input type="text" v-model="addRoomType.describe" :maxlength="100"></Input>
        </FormItem>
        <FormItem label="缓冲房量：" prop="amount">
          <Input v-model="addRoomType.amount"></Input>
        </FormItem>
      </Form>
    </Modal>

  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.hotelId = Utils.getUrlParameterByName("hotelId");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      editHotelDetailModel:false,
      channelId: 4,
      matchStatusCode:"",
      currTabName: "channelInfo",
      channelInfo: {
        channelHotelId: "",
        channelHotelName: "",
        address:""
      },
      xbedHotelInfo: {
        xbedHotelId: "",
        xbedHotelName: "",
        contactPhone: "",
        contactName: "",
        province: "",
        city: "",
        district: "",
        remark: "",
        hotspot: "",
        reminder: "",
        address: ""
      },
      roomTypeList: {
        form: {
          keyword: "",
          isPackaged: "-1"
        },
        columns: [
          {
            title: "ID",
            key: "roomTypeId",
            align: "center",
            width: 150,
            fixed: "left"
          },
          {
            title: "房型名称",
            key: "roomTypeName",
            align: "center",
            width: 350
          },
          {
            title: "打包数量",
            key: "packageRoomCount",
            align: "center",
            width: 150
          },
          {
            title: "缓冲房量",
            key: "bufferCount",
            align: "center",
            width: 150
          },
          {
            title: "匹配状态",
            key: "status",
            align: "center",
            width: 150,
            render: (h, params) => {
              let status = (params.row.matchStatus == "S50" ? "匹配中" :
                            params.row.matchStatus == "S51" ? "匹配成功" :
                            params.row.matchStatus == "S52" ? "匹配失败" : "待匹配");
              return h("Tag", {
                props: {
                  color: (params.row.matchStatus == "S50" ? "yellow" :
                            params.row.matchStatus == "S51" ? "green" :
                            params.row.matchStatus == "S52" ? "red" : "blue")
                },
              }, status);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 240,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if (this.$router) {
                          this.$router.push({
                            path: "channelRoomTypeDetail",
                            query: { roomTypeId: params.row.roomTypeId }
                          });
                        } else {
                          window.open(
                            `#/Ota/Ota/feizhuChannelRoomTypeDetail?roomTypeId=${params.row.roomTypeId}`
                          );
                        }
                      }
                    }
                  },
                  "编辑打包"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定删除 ${
                              params.row.roomTypeId
                            } - ${
                              params.row.name
                            } 吗？\n已打包的房间将重新单独售卖`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          onOk: () => {
                            this.removeRoomType(params.index);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
        loading: false,
        data: []
      },
      addRoomType: {
        display: false,
        name: '',
        amount: '0',
        bedType: '',
        describe: '',
        ratePlanName: ''
      },
      valideForm: {
        name: [
          { required: true, message: '请填写房型名称', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请填写缓冲房量', trigger: 'blur' },
          { pattern: /^[1-9]\d*|0$/, message: '格式不正确', trigger: 'blur' }
        ],
        bedType: [
          { required: true, message: '请选择床型', trigger: 'blur' }
        ],
        ratePlanName: [
          { required: true, message: '请填写套餐名称', trigger: 'blur' }
        ],
      },
      bedTypeArr: [
        "大床",
        "双床",
        "单人床",
        "水床",
        "水床-大床",
        "水床-双床",
        "水床-单人床",
        "特大床",
        "榻榻米",
        "圆床",
        "上下铺",
        "炕",
        "帐篷",
        "心型床",
        "沙发床",
        "子母床",
        "睡袋",
        "太空舱-胶囊床位",
        "通铺",
        "多张单人床",
        "多张大床",
        "多张上下铺",
        "2张床-1张大床和1张单人床",
        "3张单人床",
        "3张床-1张大床和2张双人床",
        "3张大床",
        "3张床-1张大床加2张单人床",
        "其他"
      ],
    };
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.queryHotelData();
    },
    queryHotelData() {
      if (this.currTabName !== "roomTypeList") {
        this.queryHotelBaseInfo();
      } else {
        this.queryHotelRoomTypeList();
      }
    },
    async queryHotelBaseInfo() {
      let resp = (await this.findHotel(this.token, this.env)).data;
      if (resp.status == false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      Object.keys(resp).map(key => {
        this.channelInfo.hasOwnProperty(key)
          ? (this.channelInfo[key] = resp[key])
          : "";
        this.xbedHotelInfo.hasOwnProperty(key)
          ? (this.xbedHotelInfo[key] = resp[key])
          : "";
      });
      this.matchStatusCode = resp.matchStatus;
    },
    queryWidthCondition(){
      this.roomTypeList.page = 1;
      this.queryHotelRoomTypeList();
    },
    findHotel(token, env) {
      return API.omsAPI[env].ota.findHotel(this.hotelId, token);
    },
    async queryHotelRoomTypeList(){
      this.roomTypeList.loading = true;
      const resp = (await this.getRoomTypeList(
        this.roomTypeList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      resp.result.forEach( roomTypeItem => {
        roomTypeItem.packageRoomCount >= 0 ? "" : roomTypeItem.packageRoomCount = 0;
      });
      this.roomTypeList.data = resp.result;
      this.roomTypeList.count = resp.count;
      this.roomTypeList.loading = false;
    },
    getRoomTypeList(roomTypeList, token, env) {
      let isPackaged = this.roomTypeList.form.isPackaged == -1 ? '' : this.roomTypeList.form.isPackaged;
      let params = {
        channelHotelId: this.hotelId,
        channelHotelName: this.roomTypeList.form.keyword,
        page: roomTypeList.page,
        rows: roomTypeList.pageSize,
        dockingStatus: isPackaged,

      }
      return API.omsAPI[env].ota.queryFeizhuRoomTypeList(params, token);
    },
    changePage(pageIndex) {
      this.roomTypeList.page = pageIndex;
      this.queryHotelRoomTypeList();
    },
    changePageSize(pageSize) {
      this.roomTypeList.page = 1;
      this.roomTypeList.pageSize = pageSize;
      this.queryHotelRoomTypeList();
    },
    // 添加房型
    openAddModal() {
      this.addRoomType.display = true;
    },
    // 删除房型
    removeRoomType(index) {
      let roomTypeId = this.roomTypeList.data[index].roomTypeId;
      let hotelId = this.roomTypeList.data[index].xbedHotelId;
      this.deleteRoomType(roomTypeId, hotelId);
    },
    //删除房型执行方法
    async deleteRoomType(id, hotelId){
      let resp = (await API.omsAPI[this.env].ota.removeRoomType(
        this.channelId,
        this.username,
        id,
        hotelId,
        this.token
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addRoomTypeModal.buttonLoading = false;
        this.$Notice.error({
          title: "删除房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除房型成功"
        });
        this.addRoomType = false;
        this.refreshTable();
      }
    },
    //新增门店房型
    async addRoomTypeEvent() {
      let params = {
        bedType: this.addRoomType.bedType,
        bedTypeDesc: this.addRoomType.describe,
        bufferCount: this.addRoomType.amount,
        channelHotelId: this.hotelId,
        channelId: this.channelId,
        name: this.addRoomType.name,
        operatorName: this.username,
        ratePlanName: this.addRoomType.ratePlanName,
      }
      let resp = (await API.omsAPI[this.env].ota.matchRoomType(params,this.token)).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addRoomTypeModal.buttonLoading = false;
        this.$Notice.error({
          title: "添加房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "添加房型成功"
        });
        this.addRoomType = false;
        this.refreshTable();
        this.resetAddModalData();
      }
    },
    prepareAddRoomType() {  
      this.$refs.addRoomTypeModal.buttonLoading = false;
      this.$refs.addRoomForm.validate(valid => {
        if(valid) {
          this.addRoomTypeEvent()
        }
      });
      // if (this.addRoomType.name.length==0) {
      //   this.$Notice.error({
      //     title: "添加房型失败",
      //     desc: "房型名称不能为空！"
      //   });
      //   this.$refs.addRoomTypeModal.buttonLoading = false;
      //   return;
      // } else if (this.addRoomType.name.length>30) {
      //   this.$Notice.error({
      //     title: "添加房型失败",
      //     desc: "房型名称不能超过30字！"
      //   });
      //   this.$refs.addRoomTypeModal.buttonLoading = false;
      //   return;
      // }else if(this.addRoomType.describe.length>30){
      //   this.$Notice.error({
      //     title: "添加房型失败",
      //     desc: "床宽等描述不能超过30字！"
      //   });
      //   this.$refs.addRoomTypeModal.buttonLoading = false;
      //   return;
      // } else {
      //   let count = this.addRoomType.amount;
      //   let reg = /^(0|[1-9][0-9]*)$/;
      //   if(!reg.test(count)){
      //     this.$Notice.error({
      //       title: "添加房型失败",
      //       desc: "缓冲房量格式不正确"
      //     });
      //     this.$refs.addRoomTypeModal.buttonLoading = false;
      //     return;
      //   }
      // }
      // let params = {
      //   bedType: this.addRoomType.bedType,
      //   bedTypeDesc: this.addRoomType.describe,
      //   bufferCount: this.addRoomType.amount,
      //   channelHotelId: this.hotelId,
      //   channelId: this.channelId,
      //   name: this.addRoomType.name,
      //   operatorName: this.username,
      //   ratePlanName: this.addRoomType.ratePlanName,
      // }
      // let resp = (await API.omsAPI[this.env].ota.matchRoomType(params,this.token)).data;

      // if (resp.retCode) {
      //   // 错误警告
      //   this.$refs.addRoomTypeModal.buttonLoading = false;
      //   this.$Notice.error({
      //     title: "添加房型失败",
      //     desc: resp.msg
      //   });
      // } else {
      //   this.$Notice.success({
      //     title: "添加房型成功"
      //   });
      //   this.addRoomType = false;
      //   this.refreshTable();
      //   this.resetAddModalData();
      // }
    },
    //修改门店名称
    async updateHotelName() {
      let newName = this.$refs.updateHotelNameModelInput.currentValue;
      if(newName.length===0){
        this.$Notice.error({
          title: "添加房型失败",
          desc: "房型名称不能为空！"
        });
        this.$refs.updateHotelNameModel.buttonLoading = false;
        return;
      }
      let resp = (await API.omsAPI[this.env].ota.editChannelHotel(
        //channelHotelId: number, channelHotelName: string, operatorName: string, token: string
        this.channelInfo.channelHotelId,
        this.channelInfo.channelHotelName,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.updateHotelNameModel.buttonLoading = false;
        this.$Notice.error({
          title: "修改失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "修改成功"
        });
        this.editHotelDetailModel = false;
        this.toggleTab(this.currTabName);
      }
    },
    refreshTable(){
      this.roomTypeList.form = {
        keyword: "",
        isPackaged: ""
      };
      this.roomTypeList.data = [];
      this.toggleTab(this.currTabName);
    },
    resetAddModalData(){
      this.addRoomType = {
        display: false,
        name: '',
        amount: '',
        bedType: '',
        describe: ''
      }
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}

.hotel-info {
  padding: 20px;
  span {
    line-height: 34px;
    font-size: 14px;
  }
}
</style>





// WEBPACK FOOTER //
// src/pages/ota/feizhu/hotel-detail.vue